function getTitle(tag) {
  if (tag.id !== "title") {
    return;
  }
  const value = tag.attributes.find((v) => v.key === "content");
  if (!value) {
    return;
  }
  return value.value;
}
function getTagObject(attributes) {
  return attributes.reduce((acc, v) => {
    acc[v.key] = v.value;
    return acc;
  }, {});
}
export function buildDrupalMetatags(data) {
  try {
    const link = [];
    const meta = [];
    let title = "";
    const schema = data && "schema" in data ? data.schema : "";
    const tags = data && "metatags" in data ? data.metatags : data;
    if (tags && Array.isArray(tags)) {
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        const tagTitle = getTitle(tag);
        if (tagTitle) {
          title = tagTitle;
        } else {
          const item = getTagObject(tag.attributes);
          if (tag.tag === "link") {
            link.push(item);
          } else if (tag.tag === "meta") {
            meta.push(item);
          }
        }
      }
    }
    return { link, meta, title, schema };
  } catch (e) {
    console.log("Error in Vuepal:");
    console.log(e);
  }
  return { link: [], meta: [], title: "", schema: "" };
}
